import { Navigate } from 'react-router-dom';
import { Box, Skeleton } from '@mui/material';
import { useBootstrap } from '../ui/BootstrapProvider';
import { homePath } from './home';

/**
 * /home — the workspace's home page, once its sidebar has loaded.
 *
 * Signing in lands here rather than on a fixed page: the home page is one of
 * the workspace's own sidebar pages, and the sidebar only arrives with the
 * bootstrap call made after sign-in.
 *
 * It waits for that call to have answered for this sign-in. Straight after
 * signing in, the bootstrap still holds the signed-out state — not loading, no
 * branding, no sidebar — until it notices the new session a moment later, and
 * reading that as "the chosen page is gone" sent everyone to Copilot whatever
 * their workspace had picked. Only a failed bootstrap falls back to Copilot.
 */
export default function HomeRedirect() {
  const { branding, navigation, loading, error } = useBootstrap();
  const answered = branding !== null && !loading;
  if (!answered && !error) {
    return <Box sx={{ px: 0.5 }}><Skeleton variant="rounded" height={320} /></Box>;
  }
  let saved = branding?.defaultHomePage;
  // The old chat page only for workspaces that still show it.
  if (saved === 'chat' && !branding?.showLegacyVisualizer) saved = 'copilot';
  return <Navigate to={homePath(navigation, saved)} replace />;
}
